import { createFileRoute } from "@tanstack/react-router";

const LAST_UPDATED = "July 12, 2026";

export const Route = createFileRoute("/legal/shipping")({
  head: () => ({
    meta: [
      { title: "Shipping Policy — European Wig Luxury" },
      { name: "description", content: "How and when we ship our hand-tied European wigs — discreetly, insured, and tracked." },
      { property: "og:title", content: "Shipping Policy — European Wig Luxury" },
      { property: "og:description", content: "How and when we ship our hand-tied European wigs — discreetly, insured, and tracked." },
      { property: "og:url", content: "https://europeanwigluxury.com/legal/shipping" },
    ],
    links: [{ rel: "canonical", href: "https://europeanwigluxury.com/legal/shipping" }],
  }),
  component: ShippingPage,
});

function ShippingPage() {
  return (
    <article className="container-luxe max-w-3xl py-16 md:py-24">
      <p className="eyebrow">Legal</p>
      <h1 className="mt-3 font-display text-4xl md:text-5xl">Shipping Policy</h1>
      <p className="mt-4 text-sm text-muted-foreground">Last updated: {LAST_UPDATED}</p>

      <div className="prose-luxe mt-10 space-y-8 text-base leading-relaxed text-foreground/85">
        <section>
          <h2 className="font-display text-2xl">Processing time</h2>
          <p className="mt-3">Because each wig is hand-tied and inspected individually, orders ship within <strong>3–5 business days</strong>. You'll receive a tracking number the moment your piece leaves us.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl">Shipping methods & rates</h2>
          <ul className="mt-3 space-y-2">
            <li>· <strong>United States</strong> — Complimentary insured 2-day shipping on every order.</li>
            <li>· <strong>Canada</strong> — Flat $35 USD, insured, 3–6 business days.</li>
            <li>· <strong>International</strong> — Calculated at checkout, fully insured, 5–10 business days. Duties and taxes are the recipient's responsibility.</li>
          </ul>
        </section>
        <section>
          <h2 className="font-display text-2xl">Discreet packaging</h2>
          <p className="mt-3">Every order ships in an unmarked, tamper-evident outer box. Nothing on the label indicates the contents.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl">Lost or damaged shipments</h2>
          <p className="mt-3">All orders are insured. If your package is lost, delayed beyond estimate, or arrives damaged, email <a className="text-bronze underline" href="mailto:care@europeanwigluxury.com">care@europeanwigluxury.com</a> within 7 days of the delivery date and we'll resolve it immediately.</p>
        </section>
      </div>
    </article>
  );
}
